function generateSrcSet(webImages) {
  if (!webImages.length)
    return "";
  if (isWebImage(webImages)) {
    return webImages.map(({ uri, width }) => {
      return `${uri} ${width}w`;
    }).join(", ");
  } else {
    return webImages.map(({ url, pixelWidth }) => {
      return `${url} ${pixelWidth}w`;
    }).join(", ");
  }
}
function isWebImage(images) {
  return images[0].uri !== void 0;
}
function matchSrcset({
  srcsetConditions,
  elementWidth,
  devicePixelRatio = 1
}) {
  if (!srcsetConditions || srcsetConditions.length === 0) {
    return;
  }
  for (const { type, url, value } of srcsetConditions) {
    let diff;
    if (type === "x") {
      diff = elementWidth * devicePixelRatio - elementWidth * value;
    } else {
      diff = elementWidth - value;
    }
    if (diff <= 0) {
      return url;
    }
  }
  return srcsetConditions[srcsetConditions.length - 1].url;
}
function parseSrcset(srcset) {
  const srcsetConditions = [];
  for (const src of srcset.trim().split(/\s*,\s*/g)) {
    const [url, condition = "0w"] = src.split(" ");
    const type = condition.slice(-1);
    const value = Number(condition.slice(0, -1));
    srcsetConditions.push({ type, url, value });
  }
  return srcsetConditions.sort((a, b) => a.value - b.value);
}
export {
  generateSrcSet,
  matchSrcset,
  parseSrcset
};
